:host {
  display: flex;
  height: 100%;
  align-items: center;

  .cell-label {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: var(--font-family-secondary);
    font-size: var(--body-size-medium);
  }

  .copy-content-pivot {
    position: relative;
    &.visible {
      .copy-content {
        opacity: 1;
      }
    }
  }

  .copy-content {
    display: inline-block;
    width: 24px;
    height: auto;
    opacity: 0;
    transition: all 0.2s ease;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: calc(var(--spacer) * -1);

    .text-content {
      display: none;
    }

    &.visible {
      opacity: 1;
    }
  }
}

:host([cancopycontent]) {
  padding-right: calc(var(--spacer) * 2);
}

.multiple-value__counter {
  padding-left: var(--spacer);
}

::slotted(*) {
  font-family: var(--font-family-secondary);
}
